export default __webpack_public_path__ + "static/zaklepschronisko-promo@2x-ef7571337c0249c3a5104e4555fe9c58.jpg";